module.exports = __webpack_public_path__ + "img/bory-logo.b09d9dbb.png";